module.exports = __webpack_public_path__ + "img/I2C_Fig10.ea1feac7.png";